"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = exports.NetMDRejected = exports.NetMDNotImplemented = exports.NetMDError = void 0;
// https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
// I could have used the make-error library
var NetMDError = /** @class */ (function (_super) {
    __extends(NetMDError, _super);
    function NetMDError(m) {
        var _this = _super.call(this, m) || this;
        Object.setPrototypeOf(_this, NetMDError.prototype);
        return _this;
    }
    return NetMDError;
}(Error));
exports.NetMDError = NetMDError;
var NetMDNotImplemented = /** @class */ (function (_super) {
    __extends(NetMDNotImplemented, _super);
    function NetMDNotImplemented(m) {
        var _this = _super.call(this, m) || this;
        Object.setPrototypeOf(_this, NetMDNotImplemented.prototype);
        return _this;
    }
    return NetMDNotImplemented;
}(NetMDError));
exports.NetMDNotImplemented = NetMDNotImplemented;
var NetMDRejected = /** @class */ (function (_super) {
    __extends(NetMDRejected, _super);
    function NetMDRejected(m) {
        var _this = _super.call(this, m) || this;
        Object.setPrototypeOf(_this, NetMDRejected.prototype);
        return _this;
    }
    return NetMDRejected;
}(NetMDError));
exports.NetMDRejected = NetMDRejected;
var Status;
(function (Status) {
    // NetMD Protocol return status (first byte of request)
    Status[Status["control"] = 0] = "control";
    Status[Status["status"] = 1] = "status";
    Status[Status["specificInquiry"] = 2] = "specificInquiry";
    Status[Status["notify"] = 3] = "notify";
    Status[Status["generalInquiry"] = 4] = "generalInquiry";
    //  ... (first byte of response)
    Status[Status["notImplemented"] = 8] = "notImplemented";
    Status[Status["accepted"] = 9] = "accepted";
    Status[Status["rejected"] = 10] = "rejected";
    Status[Status["inTransition"] = 11] = "inTransition";
    Status[Status["implemented"] = 12] = "implemented";
    Status[Status["changed"] = 13] = "changed";
    Status[Status["interim"] = 15] = "interim";
})(Status = exports.Status || (exports.Status = {}));
//# sourceMappingURL=netmd-shared-objects.js.map